/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { queryClient } from '@lib/react-query';
import { notifications } from '@mantine/notifications';
// I18n
import { useTranslation } from 'react-i18next';

export const removeMultiple = (
	data: any
): Promise<{
	user: any;
}> => {
	return apiClient.delete(`/sites`, {
		data,
	});
};

export const useRemoveMultiple = (
	page: number,
	size: number
) => {
	const { t } = useTranslation();
	const {
		mutate,
		isPending: isLoading,
		isIdle,
	} = useMutation({
		mutationFn: removeMultiple,
		onSuccess: () => {
			notifications.show({
				title: t('global.success'),
				message: t(
					'sites.notifications.siteSuccessfullyDeleted'
				),
				color: 'success',
			});
			queryClient.invalidateQueries({
				queryKey: ['sites', { page: page, size: size }],
			});
		},
		onError: (error: any) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading, isIdle };
};
